module.exports = __webpack_public_path__ + "static/img/line.41c88b4a.png";